import React from 'react';
import { VideoPlayer } from '@rcm/vimeo-player';
import { CongratulationsStepConfig } from '../../types/CongratulationsStepConfig';
interface Props {
    step: CongratulationsStepConfig;
}

export const Congratulations = ({ step }: Props) => {
    return <div className="congratulations-page">
        <div className="congratulations-page-video-container">
            <VideoPlayer video={step.video} />
        </div>
        <div dangerouslySetInnerHTML={{ __html: step.bodyHtml }} />
    </div>;
};
